/*
Monotype Foundry Platform API
Version 1.0.0

Definition: SalesReportRequest

Properties:
  filter: object
  paging: object
  searchQuery: string
  sorting: object
*/

var SalesReportRequest = (function () {
  function validateSalesReportRequest (arg) {
    // Validate filter
    if (arg.filter && !(typeof arg.filter === 'object')) {
      throw new Error('SalesReportRequest.filter: Wrong type: Got \'' + (typeof arg.filter) + '\', but expected: \'object\'')
    }
    // Validate paging
    if (arg.paging && !(typeof arg.paging === 'object')) {
      throw new Error('SalesReportRequest.paging: Wrong type: Got \'' + (typeof arg.paging) + '\', but expected: \'object\'')
    }
    // Validate searchQuery
    if (arg.searchQuery && !(typeof arg.searchQuery === 'string')) {
      throw new Error('SalesReportRequest.searchQuery: Wrong type: Got \'' + (typeof arg.searchQuery) + '\', but expected: \'string\'')
    }
    // Validate sorting
    if (arg.sorting && !(typeof arg.sorting === 'object')) {
      throw new Error('SalesReportRequest.sorting: Wrong type: Got \'' + (typeof arg.sorting) + '\', but expected: \'object\'')
    }
  }
  function buildSalesReportRequest (arg) {
    var SalesReportRequest = arg
    // Complete filter
    // Expected Type: object
    SalesReportRequest.filter = SalesReportRequest.filter || {}
    // Complete paging
    // Expected Type: object
    SalesReportRequest.paging = SalesReportRequest.paging || {}
    // Complete searchQuery
    // Expected Type: string
    SalesReportRequest.searchQuery = SalesReportRequest.searchQuery || ''
    // Complete sorting
    // Expected Type: object
    SalesReportRequest.sorting = SalesReportRequest.sorting || {}
    return SalesReportRequest
  }
  return {
    validate: validateSalesReportRequest,
    build: buildSalesReportRequest
  }
})()

module.exports = SalesReportRequest
